import { render } from "./AddToCart.vue?vue&type=template&id=028b97e2&scoped=true"
import script from "./AddToCart.vue?vue&type=script&lang=js"
export * from "./AddToCart.vue?vue&type=script&lang=js"

import "./AddToCart.vue?vue&type=style&index=0&id=028b97e2&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-028b97e2"]])

export default __exports__